import { CLEAR_PAGE } from '../base/types';
import { FETCH_CHECKOUTS } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: {}
};

const checkoutsReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_CHECKOUTS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_CHECKOUTS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_CHECKOUTS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'checkouts' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default checkoutsReducer;
